import React, { useContext, useEffect, useRef, useState } from 'react'
import { Formik, Form, Field } from 'formik';
import { getImages } from '../Const';
import PdfDownloader from './EditDocuSign/PdfDownloader';
import html2pdf from 'html2pdf.js';
import jsPDF from 'jspdf';
// import ModalLayoutNew from '../Modals/ModalLayoutNew';
// import EmailBuilderModal from './EmailBuilderModal';
import ListFormField from './EditDocuSign/ListFormField';
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';
import { LeadsContext } from '../Context/LeadsContext';
import { useLocation, useParams } from 'react-router-dom';
import TopSection from '../Common/TopSection';
import Layout from '../Layouts/Layout';
import { UserContext } from '../Context/UserContext';

const EditDocuSign = () => {
    const location = useLocation();
    const { vin } = useParams();
    const [selectedID, setSelectedID] = useState(vin); // State for id
    const { filteredLeads, numberFormatter, getAccutradeData, sendAccutradePDF } = useContext(LeadsContext);
    
    const pdfRef = useRef(null);
    const targetRef = useRef(null);
    const page2Ref = useRef(null);
    const formikRef = useRef();
    const [openEditModal, setOpenEditModal] = useState(false);

    const queryParameters = new URLSearchParams(window.location.search)
    const query_id = queryParameters.get("accutrade_id");

    const [leadData,setLeadData] = useState([]);

    const fetchData = async () => {
        const data = await getAccutradeData(query_id);

        setLeadData(data);
    }

    useEffect(() => {
        if(query_id) fetchData();
    },[query_id]);

    // Print and Download
    const [generatePdf, setGeneratePdf] = useState(false);
    const handleDownloadPDF = async () => {
        setGeneratePdf(true);
        const element = pdfRef.current;
        try {
            await html2pdf().from(element).save();
            setGeneratePdf(true);
        } catch (error) {
            console.error("PDF generation failed", error);
        } finally {
            setGeneratePdf(false);
        }
    };

    const signaturePositionTest = async () => {
        //console.log(page2Ref.current.offsetWidth);

        if (page2Ref.current && targetRef.current) {
            const dpiElement = document.createElement('div');
            dpiElement.style.width = '1in';
            document.body.appendChild(dpiElement);
            var pixelsPerInch = dpiElement.offsetWidth;
            document.body.removeChild(dpiElement);

            const elementRect = targetRef.current.getBoundingClientRect();
            const targetRect = page2Ref.current.getBoundingClientRect();

            // Calculate the relative position
            const top = elementRect.top - targetRect.top;
            const left = elementRect.left - targetRect.left;

            pixelsPerInch = 82;

            var posRatio = 0.8580553746339536;

            console.log(pixelsPerInch, top, left, posRatio * top , posRatio * left + 5);
        }
    };
    const handlePrint = () => {
        // setIsLoading(true); // Show loader
        setTimeout(() => {
            const printContent = pdfRef.current.innerHTML;
            const printWindow = window.open('', '', 'height=600,width=800');
            printWindow.document.write('<html><head><title>Print</title></head><body>');
            printWindow.document.write(printContent);
            printWindow.document.write('</body></html>');
            printWindow.document.close();
            printWindow.print();
            // setIsLoading(false); // Hide loader
        }, 500); // Optional delay for UI consistency
    };

    const [visibleBox, setVisibleBox] = useState(null); 
    const handleDefineStyle = (fieldName) => {
        setVisibleBox(visibleBox === fieldName ? null : fieldName);
    };
    const closeDefineStyle = () => {
        setVisibleBox(null)
    }
    const [fontSize, setFontSize] = useState('');
    const [color, setColor] = useState('#666666');
    const setFieldStyle = (fieldName, newStyle) => {
        initialValues[fieldName] = { ...initialValues[fieldName], ...newStyle };
    };
    // Email Send
    const [openEmailModal, setOpenEmailModal] = useState(false);
    const handleEmailBtn = () => {
        setOpenEmailModal(true)
    }
    const closeEmailBtn = () => {
        setOpenEmailModal(false)
    }
    const [generateText, setGenerateText] = useState(false);
    const [pdfFile, setPdfFile] = useState(null); 
    const [pdfFileName, setPdfFileName] = useState(null);
    const emailGeneratePdf = () => {
        const element = pdfRef.current;
        const fileName = "Appraisal_Offer.pdf";
        setPdfFileName(fileName);
        setGenerateText(true)
        const options = {
            margin: 0,
            filename: fileName, // Set the file name here
            image: { type: "jpeg", quality: 0.98 },
            html2canvas: { scale: 2 },
            jsPDF: { unit: "in", format: "letter", orientation: "portrait" },
        };

        html2pdf()
            .set(options)
            .from(element)
            .outputPdf("datauristring") // Generate the PDF as a Base64 string
            .then((pdfString) => {
                setPdfFile(pdfString); 
                setOpenEmailModal(true); 
                

                sendDocusign(pdfString);

                
            })
            .catch((error) => {
            console.error("PDF generation failed:", error);
            });
        };
        // Data update according to Appraisal details action
        
  /*const allData = [
    ...commonCqData,
    ...leadsBoyntonBeach,
    ...leadsPompanoBeach
  ];*/

  const sendDocusign = async (pdfString) => {    

    var values = {
        'seller_email':formikRef.current.values.seller_email.value,
        'seller_name':formikRef.current.values.seller_name.value,
        //'buyer_email':formikRef.current.values.buyer_email.value,
        //'buyer_name':formikRef.current.values.buyer_name.value,
        'document_base64':pdfString
    }

    /*if (page2Ref.current && targetRef.current) {
        const dpiElement = document.createElement('div');
        dpiElement.style.width = '1in';
        document.body.appendChild(dpiElement);
        var pixelsPerInch = dpiElement.offsetWidth;
        document.body.removeChild(dpiElement);

        const elementRect = targetRef.current.getBoundingClientRect();
        const targetRect = page2Ref.current.getBoundingClientRect();

        // Calculate the relative position
        const top = elementRect.top - targetRect.top;
        const left = elementRect.left - targetRect.left;

        var posRatio = 0.8580553746339536;

        console.log(pixelsPerInch, top, left, posRatio * top , posRatio * left + 5);

        values.sigX = posRatio * left + 5;
        values.sigY = posRatio * top;
    }*/

    const data = await sendAccutradePDF(values);

    setGenerateText(false);
  }

  const [initialValues, setInitialValues] = useState({
        date: {
            enabled: true,
            value: '',
            fontSize: '' || '12',
            color: '' || '#666666',
        },
        seller_name: {
            enabled: true,
            value: '',
            fontSize: '' || '12',
            color: '' || '#666666',
        },
        seller_email: {
            enabled: true,
            value: '',
            fontSize: '' || '12',
            color: '' || '#666666',
        },
        seller_address: {
            enabled: true,
            value: '',
            fontSize: '' || '12',
            color: '' || '#666666',
        },
        buyer_name: {
            enabled: true,
            value: '',
            fontSize: '' || '12',
            color: '' || '#666666',
        },
        buyer_email: {
            enabled: true,
            value: '',
            fontSize: '' || '12',
            color: '' || '#666666',
        },
        price: {
            enabled: true,
            value: '',
            fontSize: '12',
            color: color || '#666666',
        },
        adjustments: {
            enabled: true,
            value: '',
            fontSize: '12',
            color: color || '#666666',
        },
        year: {
            enabled: true,
            value: '',
            fontSize: '12',
            color: '#666666',
        },
        make: {
            enabled: true,
            value: '',
            fontSize: '12',
            color: '#666666',
        },
        model: {
            enabled: true,
            value: '',
            fontSize: '12',
            color: '#666666',
        },
        trim: {
            enabled: true,
            value: '',
            fontSize: '12',
            color: '#666666',
        },
        color: {
            enabled: true,
            value: '',
            fontSize: '16',
            color: '#10758d',
        },
        vin: {
            enabled: true,
            value: '',
            fontSize: '33',
            color: '#666666',
        },
        mileage: {
            enabled: true,
            value: '',
            fontSize: '12',
            color: '#666666',
        },
    });

//   useEffect(() => {
//     const queryParams = new URLSearchParams(location.search);
//     console.log("queryParams", queryParams)
//     const id = queryParams.get("Vin_Number");
//     setSelectedID(id);
// }, [location.search]);
    useEffect(() => {
        const updatedData = leadData;
        console.log(leadData);

        var today = new Date();

        var tzoffset = today.getTimezoneOffset() * 60000;

        var appraisal_date_obj = leadData.requestdate ? new Date(Date.parse(leadData.requestdate) - tzoffset) : new Date();

        var appraisal_date_str = String(appraisal_date_obj.getMonth() + 1).padStart(2, '0') + "/" + String(appraisal_date_obj.getDate()).padStart(2, '0') + "/" + String(appraisal_date_obj.getFullYear()).substr(-2);

                

        setInitialValues(prevValues => ({
            ...prevValues,
            date: {
                enabled: true,
                value: appraisal_date_str || prevValues?.date.value || '2025-06-17',
                fontSize: '' || '12',
                color: '' || '#666666',
            },
            seller_name: {
                enabled: true,
                value: updatedData?.customer_contact_name || prevValues?.seller_name.value,
                fontSize: '12',
                color: color || '#666666',
            },
            seller_email: {
                enabled: true,
                //value: updatedData?.customer_contact_email || prevValues?.seller_email.value,
                value: "matt+seller@doubleclutch.com" || prevValues?.seller_email.value,
                fontSize: '12',
                color: color || '#666666',
            },
            seller_address: {
                enabled: true,
                value: updatedData?.customer_contact_address_city || prevValues?.seller_address.value,
                fontSize: '12',
                color: '#666666',
            },
            buyer_name: {
                enabled: true,
                value: updatedData?.vendor_contact_name || prevValues?.buyer_name.value,
                fontSize: '12',
                color: color || '#666666',
            },
            buyer_email: {
                enabled: true,
                //value: updatedData?.vendor_contact_email || prevValues?.buyer_email.value,
                value: "matt+buyer@doubleclutch.com" || prevValues?.buyer_email.value,
                fontSize: '12',
                color: color || '#666666',
            },
            price: {
                enabled: true,
                value: updatedData?.vehicle_1_price || prevValues?.price.value,
                fontSize: '12',
                color: '#666666',
            },
            adjustments: {
                enabled: true,
                value: prevValues?.adjustments.value,
                fontSize: '12',
                color: '#666666',
            },
            year: {
                enabled: true,
                value: (updatedData?.vehicle_1_year) || prevValues?.year.value,
                fontSize: '12',
                color: '#666666',
            },
            make: {
                enabled: true,
                value: (updatedData?.vehicle_1_make) || prevValues?.make.value,
                fontSize: '12',
                color: '#666666',
            },
            model: {
                enabled: true,
                value: updatedData?.vehicle_1_model || prevValues?.model.value,
                fontSize: '16',
                color: '#10758d',
            },
            trim: {
                enabled: true,
                value: updatedData?.vehicle_1_trim || prevValues?.trim.value,
                fontSize: '33',
                color: '#666666',
            },
            color: {
                enabled: true,
                value: updatedData?.vehicle_1_colorcombination_exteriorcolor || prevValues?.color.value,
                fontSize: '12',
                color: '#666666',
            },
            vin: {
                enabled: true,
                value: updatedData?.vehicle_1_vin || prevValues?.vin.value,
                fontSize: '12',
                color: '#666666',
            },
            mileage: {
                enabled: true,
                value: updatedData?.vehicle_1_odometer || prevValues?.mileage.value,
                fontSize: '12',
                color: '#666666',
            },
        }));
    }, [leadData]);
  return (
    <>
            <Layout>
                <TopSection />
                <section className='main-block py-4'>
                    <div className='container-fluid'>
                        <div className='d-flex align-items-center justify-content-between mb-3'>
                            <div className='lg-title text-uppercase font-26'>Edit DocuSign</div>
                            <div>
                                {generateText ? 
                                <button type='button' className='blue-transparent-btn w-165 text-uppercase px-2 me-3'>
                                Generating...
                            </button>
                                : <button type='button' className='blue-transparent-btn w-165 text-uppercase px-2 me-3' onClick={emailGeneratePdf}>
                                        <span className='apl-icon'><img src={getImages('email_icon.png')}/></span> Email
                                    </button>
                                }
                                {generatePdf ? 
                                    <button type='button' className='blue-transparent-btn w-165 text-uppercase px-2 me-3'>
                                        Generating...
                                    </button> :
                                    <button type='button' className='blue-transparent-btn w-165 text-uppercase px-2 me-3' onClick={handleDownloadPDF}>
                                        <span className='apl-icon'><img src={getImages('download_icon.png')}/></span> Download
                                    </button>
                                }
                                <button type='button' className='blue-transparent-btn w-165 text-uppercase px-2' onClick={handlePrint}>
                                    <span className='apl-icon'><img src={getImages('print_icon.png')}/></span> Print
                                </button>
                            </div>
                        </div>
                        
                        <Formik
                            initialValues={initialValues}
                            enableReinitialize={true}
                            innerRef={formikRef}
                            onSubmit={(values) => {
                                console.log('Form Submitted:', values);
                            }}
                        >
                            {({ values, setFieldValue }) => (
                                <Form className=''>
                                    <div className='gray-box ab-flex d-flex p-0'>
                                        <div className='ab-left'>
                                            <div className='ab-box'>
                                                <div className='ab-header'>CUstomer Info</div>
                                                <div className='ab-body'>
                                                    <ul className='ab-list'>
                                                        <ListFormField
                                                            fieldName="date"
                                                            textLabel='Date'
                                                            values={values}
                                                            handleDefineStyle={handleDefineStyle}
                                                            visibleBox={visibleBox}
                                                            setFieldStyle={setFieldStyle}
                                                            closeDefineStyle={closeDefineStyle}
                                                            setFieldValue={setFieldValue}
                                                        />
                                                        <ListFormField
                                                            fieldName="seller_name"
                                                            textLabel='Seller Name'
                                                            values={values}
                                                            handleDefineStyle={handleDefineStyle}
                                                            visibleBox={visibleBox}
                                                            setFieldStyle={setFieldStyle}
                                                            closeDefineStyle={closeDefineStyle}
                                                            setFieldValue={setFieldValue}
                                                        />
                                                        <ListFormField
                                                            fieldName="seller_email"
                                                            textLabel='Seller Email'
                                                            values={values}
                                                            handleDefineStyle={handleDefineStyle}
                                                            visibleBox={visibleBox}
                                                            setFieldStyle={setFieldStyle}
                                                            closeDefineStyle={closeDefineStyle}
                                                            setFieldValue={setFieldValue}
                                                        />
                                                        <ListFormField
                                                            fieldName="seller_address"
                                                            textLabel='Seller Address'
                                                            values={values}
                                                            handleDefineStyle={handleDefineStyle}
                                                            visibleBox={visibleBox}
                                                            setFieldStyle={setFieldStyle}
                                                            closeDefineStyle={closeDefineStyle}
                                                            setFieldValue={setFieldValue}
                                                        />
                                                        <ListFormField
                                                            fieldName="buyer_name"
                                                            textLabel='Buyer Name'
                                                            values={values}
                                                            handleDefineStyle={handleDefineStyle}
                                                            visibleBox={visibleBox}
                                                            setFieldStyle={setFieldStyle}
                                                            closeDefineStyle={closeDefineStyle}
                                                            setFieldValue={setFieldValue}
                                                        />
                                                        {/*<ListFormField
                                                            fieldName="buyer_email"
                                                            textLabel='Buyer Email'
                                                            values={values}
                                                            handleDefineStyle={handleDefineStyle}
                                                            visibleBox={visibleBox}
                                                            setFieldStyle={setFieldStyle}
                                                            closeDefineStyle={closeDefineStyle}
                                                            setFieldValue={setFieldValue}
                                                        />*/}
                                                    </ul>
                                                </div>
                                            </div>
                                            <div className='ab-box'>
                                                <div className='ab-header'>Vehicle Info</div>
                                                <div className='ab-body'>
                                                    <ul className='ab-list'>
                                                        <ListFormField
                                                            fieldName="price"
                                                            textLabel='Price'
                                                            values={values}
                                                            handleDefineStyle={handleDefineStyle}
                                                            visibleBox={visibleBox}
                                                            setFieldStyle={setFieldStyle}
                                                            closeDefineStyle={closeDefineStyle}
                                                            setFieldValue={setFieldValue}
                                                        />
                                                        <ListFormField
                                                            fieldName="adjustments"
                                                            textLabel='Adjustments'
                                                            values={values}
                                                            handleDefineStyle={handleDefineStyle}
                                                            visibleBox={visibleBox}
                                                            setFieldStyle={setFieldStyle}
                                                            closeDefineStyle={closeDefineStyle}
                                                            setFieldValue={setFieldValue}
                                                        />
                                                        <ListFormField
                                                            fieldName="year"
                                                            textLabel='Year'
                                                            values={values}
                                                            handleDefineStyle={handleDefineStyle}
                                                            visibleBox={visibleBox}
                                                            setFieldStyle={setFieldStyle}
                                                            closeDefineStyle={closeDefineStyle}
                                                            setFieldValue={setFieldValue}
                                                        />
                                                        <ListFormField
                                                            fieldName="make"
                                                            textLabel='Make'
                                                            values={values}
                                                            handleDefineStyle={handleDefineStyle}
                                                            visibleBox={visibleBox}
                                                            setFieldStyle={setFieldStyle}
                                                            closeDefineStyle={closeDefineStyle}
                                                            setFieldValue={setFieldValue}
                                                        />
                                                        <ListFormField
                                                            fieldName="model"
                                                            textLabel='Model'
                                                            values={values}
                                                            handleDefineStyle={handleDefineStyle}
                                                            visibleBox={visibleBox}
                                                            setFieldStyle={setFieldStyle}
                                                            closeDefineStyle={closeDefineStyle}
                                                            setFieldValue={setFieldValue}
                                                        />
                                                        <ListFormField
                                                            fieldName="trim"
                                                            textLabel='Trim'
                                                            values={values}
                                                            handleDefineStyle={handleDefineStyle}
                                                            visibleBox={visibleBox}
                                                            setFieldStyle={setFieldStyle}
                                                            closeDefineStyle={closeDefineStyle}
                                                            setFieldValue={setFieldValue}
                                                        />
                                                        <ListFormField
                                                            fieldName="color"
                                                            textLabel='Color'
                                                            values={values}
                                                            handleDefineStyle={handleDefineStyle}
                                                            visibleBox={visibleBox}
                                                            setFieldStyle={setFieldStyle}
                                                            closeDefineStyle={closeDefineStyle}
                                                            setFieldValue={setFieldValue}
                                                        />
                                                        <ListFormField
                                                            fieldName="vin"
                                                            textLabel='VIN'
                                                            values={values}
                                                            handleDefineStyle={handleDefineStyle}
                                                            visibleBox={visibleBox}
                                                            setFieldStyle={setFieldStyle}
                                                            closeDefineStyle={closeDefineStyle}
                                                            setFieldValue={setFieldValue}
                                                        />
                                                        <ListFormField
                                                            fieldName="mileage"
                                                            textLabel='Mileage'
                                                            values={values}
                                                            handleDefineStyle={handleDefineStyle}
                                                            visibleBox={visibleBox}
                                                            setFieldStyle={setFieldStyle}
                                                            closeDefineStyle={closeDefineStyle}
                                                            setFieldValue={setFieldValue}
                                                        />
                                                    </ul>
                                                </div>
                                            </div>
                                        </div>
                                        <div className='ab-right'>
                                            <PdfDownloader 
                                                pdfRef={pdfRef} 
                                                values={values}
                                                targetRef={targetRef}
                                                page2Ref={page2Ref}
                                            />
                                        </div>
                                    </div>
                                </Form>
                            )}
                        </Formik>
                    </div>
                </section>
            </Layout>
        {/* </Layout> */}
        {/* <ModalLayoutNew open={openEmailModal} close={closeEmailBtn} modalWidth={650}>
            <EmailBuilderModal 
                close={closeEmailBtn} 
                pdfFile={pdfFile}
                pdfFileName={pdfFileName}
            />   
        </ModalLayoutNew> */}
    </>
  )
}

export default EditDocuSign